export default "__VITE_ASSET__0b239039__"